import ProfileApiEnum from "../Enums/EnumProfileApi";

export const GET_PROFILE_FIELDS_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.GET_PROFILE_FIELDS
export const PATCH_AVATAR_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.PATCH_AVATAR
export const POST_FRIEND_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.POST_FRIEND
export const PATCH_ACCEPT_FRIENDSHIP_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.PATCH_ACCEPT_FRIENDSHIP
export const DELETE_DENIED_FRIENDSHIP_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.DELETE_DENIED_FRIENDSHIP
export const GET_FRIENDSHIP_INVITES_API_URL = process.env.REACT_APP_API_URL + ProfileApiEnum.GET_FRIENDSHIP_INVITES